import { Alert } from '@/types/community/alert';

// Helper function to get dates relative to current date
function getRelativeDate(daysOffset: number, hour: number = 9, minute: number = 0): Date {
  const date = new Date();
  date.setDate(date.getDate() + daysOffset);
  date.setHours(hour, minute, 0, 0);
  return date;
}

export const alerts: Alert[] = [
  // Recent alerts (last few days)
  {
    id: 'ALT001',
    title: 'Corte de Energía',
    description: 'Mantenimiento programado causando corte de energía en Bloque A',
    type: 'maintenance',
    status: 'active',
    block: {
      id: 'BLOCK001',
      name: 'Bloque A'
    },
    startTime: getRelativeDate(-2, 20, 0),
    endTime: getRelativeDate(-2, 22, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT002',
    title: 'Mantenimiento de Piscina',
    description: 'La piscina estará cerrada para limpieza y mantenimiento',
    type: 'maintenance',
    status: 'active',
    amenity: {
      id: 'AMENITY001',
      name: 'Piscina'
    },
    startTime: getRelativeDate(-1, 8, 0),
    endTime: getRelativeDate(-1, 18, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT003',
    title: 'Prueba de Alarma de Incendio',
    description: 'Se realizará la prueba mensual del sistema de alarma de incendio',
    type: 'security',
    status: 'active',
    startTime: getRelativeDate(0, 10, 0),
    endTime: getRelativeDate(0, 11, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT004',
    title: 'Alerta de Seguridad',
    description: 'Actividad sospechosa reportada en área de estacionamiento',
    type: 'security',
    status: 'active',
    startTime: getRelativeDate(-3, 22, 0),
    endTime: getRelativeDate(-2, 6, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT005',
    title: 'Mantenimiento de Ascensor',
    description: 'El ascensor en Bloque C estará fuera de servicio por mantenimiento',
    type: 'maintenance',
    status: 'active',
    block: {
      id: 'BLOCK003',
      name: 'Bloque C'
    },
    startTime: getRelativeDate(1, 9, 0),
    endTime: getRelativeDate(1, 17, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },

  // Past week alerts
  {
    id: 'ALT006',
    title: 'Interrupción del Suministro de Agua',
    description: 'El suministro de agua será interrumpido temporalmente para reparaciones de tuberías',
    type: 'maintenance',
    status: 'resolved',
    block: {
      id: 'BLOCK002',
      name: 'Bloque B'
    },
    startTime: getRelativeDate(-7, 14, 0),
    endTime: getRelativeDate(-7, 16, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT007',
    title: 'Mantenimiento de Internet',
    description: 'Mantenimiento programado de internet afectando todos los bloques',
    type: 'maintenance',
    status: 'resolved',
    startTime: getRelativeDate(-8, 2, 0),
    endTime: getRelativeDate(-8, 4, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT008',
    title: 'Limpieza del Estacionamiento',
    description: 'El estacionamiento será limpiado y repintado',
    type: 'maintenance',
    status: 'resolved',
    startTime: getRelativeDate(-9, 6, 0),
    endTime: getRelativeDate(-9, 14, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT009',
    title: 'Actualización de Equipos de Gimnasio',
    description: 'Instalación de nuevos equipos de gimnasio en progreso',
    type: 'maintenance',
    status: 'resolved',
    amenity: {
      id: 'AMENITY002',
      name: 'Centro de Fitness'
    },
    startTime: getRelativeDate(-12, 8, 0),
    endTime: getRelativeDate(-10, 18, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT010',
    title: 'Actualización de Contacto de Emergencia',
    description: 'Por favor actualice su información de contacto de emergencia',
    type: 'other',
    status: 'active',
    startTime: getRelativeDate(-5, 9, 0),
    endTime: getRelativeDate(8, 17, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },

  // Past month alerts
  {
    id: 'ALT011',
    title: 'Mantenimiento del Sistema HVAC',
    description: 'Mantenimiento del sistema de calefacción y refrigeración en todos los bloques',
    type: 'maintenance',
    status: 'resolved',
    startTime: getRelativeDate(-15, 8, 0),
    endTime: getRelativeDate(-15, 16, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT012',
    title: 'Instalación de Cámaras de Seguridad',
    description: 'Nuevas cámaras de seguridad siendo instaladas en áreas comunes',
    type: 'security',
    status: 'resolved',
    startTime: getRelativeDate(-18, 9, 0),
    endTime: getRelativeDate(-16, 17, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT013',
    title: 'Advertencia Meteorológica',
    description: 'Se espera clima severo - asegure artículos exteriores',
    type: 'weather',
    status: 'resolved',
    startTime: getRelativeDate(-20, 14, 0),
    endTime: getRelativeDate(-19, 8, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT014',
    title: 'Inspección de Seguridad contra Incendios',
    description: 'Se realizará la inspección anual de seguridad contra incendios',
    type: 'security',
    status: 'resolved',
    startTime: getRelativeDate(-22, 10, 0),
    endTime: getRelativeDate(-22, 15, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT015',
    title: 'Reparaciones de Techo',
    description: 'Reparaciones de emergencia del techo en Bloque D',
    type: 'maintenance',
    status: 'resolved',
    block: {
      id: 'BLOCK004',
      name: 'Bloque D'
    },
    startTime: getRelativeDate(-25, 7, 0),
    endTime: getRelativeDate(-23, 18, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },

  // Older alerts
  {
    id: 'ALT016',
    title: 'Emergencia de Plomería',
    description: 'Problema mayor de plomería en el sótano del Bloque A',
    type: 'maintenance',
    status: 'resolved',
    block: {
      id: 'BLOCK001',
      name: 'Bloque A'
    },
    startTime: getRelativeDate(-30, 6, 0),
    endTime: getRelativeDate(-29, 20, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT017',
    title: 'Vehículo No Autorizado',
    description: 'Vehículo no autorizado estacionado en lugar de residente',
    type: 'security',
    status: 'resolved',
    startTime: getRelativeDate(-32, 16, 0),
    endTime: getRelativeDate(-31, 10, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT018',
    title: 'Detección de Fuga de Gas',
    description: 'Fuga de gas detectada en Bloque B - evacuación inmediata',
    type: 'emergency',
    status: 'resolved',
    block: {
      id: 'BLOCK002',
      name: 'Bloque B'
    },
    startTime: getRelativeDate(-35, 19, 0),
    endTime: getRelativeDate(-35, 23, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT019',
    title: 'Reunión Comunitaria',
    description: 'Reunión mensual de la comunidad en la casa club',
    type: 'other',
    status: 'resolved',
    startTime: getRelativeDate(-40, 18, 0),
    endTime: getRelativeDate(-40, 20, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  },
  {
    id: 'ALT020',
    title: 'Mantenimiento Anual',
    description: 'Mantenimiento e inspección anual del edificio',
    type: 'maintenance',
    status: 'resolved',
    startTime: getRelativeDate(-45, 8, 0),
    endTime: getRelativeDate(-43, 17, 0),
    workspace: {
      id: 'WS001',
      name: 'Apartamentos Sunset',
      slug: 'sunset-apartments'
    }
  }
]; 